import { OrganizationType } from "@remi/enums/organization-type";

import { UNIFIED_SIDEBAR_FEATURE_FLAG } from "~/components/favorites/useEntityFavorites";
import { useUserProfile } from "~/contexts/UserProfileContext";
import { useFeatureFlagWithNonProdDefault } from "~/hooks/useFeatureFlagWithNonProdDefault";

// Unified sidebar + favorites are Remi-internal only: external orgs (partners like Sunrun,
// contractors, vendors, homeowners) keep the legacy nav even with the flag on. Undefined is kept for
// Remi users so callers can still tell "flag not resolved yet" from "off".
export const useUnifiedSidebarEnabled = (): boolean | undefined => {
  const { user } = useUserProfile();
  const flag = useFeatureFlagWithNonProdDefault(UNIFIED_SIDEBAR_FEATURE_FLAG);
  if (user.person.organization.type !== OrganizationType.REMI_INTERNAL) {
    return false;
  }
  return flag;
};
